
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  PS_Supplier_Purchase_Docs_Result.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\PS_Supplier_Purchase_Docs_Result.ts

export class PS_Supplier_Purchase_Docs_Result {

  // int? SupplierId
  public SupplierId?: number=null;

  // int? RefDocId
  public RefDocId?: number=null;

  // string Cod
  public Cod?: string=null;

  // int DocTypId
  public DocTypId: number=0;

  // string LblCod
  public LblCod?: string=null;

  // string LibDoc
  public LibDoc?: string=null;

  // string TemplatePath
  public TemplatePath?: string=null;

  // byte TopInputDat
  public TopInputDat: number=0;

  // string Informations
  public Informations?: string=null;

  // byte? TopDatInputIsEcheance
  public TopDatInputIsEcheance?: number=null;

  // string Screen
  public Screen?: string=null;

  // byte? TopInputDescription
  public TopInputDescription?: number=null;

  // byte? TopMultiple
  public TopMultiple?: number=null;

  // int? DisplayRank
  public DisplayRank?: number=null;

  // int? DocId
  public DocId?: number=null;

  // string FullPath
  public FullPath?: string=null;

  // DateTime? DateExpi
  public DateExpi?: Date=null;

  // string Description
  public Description?: string=null;

  // DateTime? DateDoc
  public DateDoc?: Date=null;

  // int? StatutId
  public StatutId?: number=null;

  // string StatutCod
  public StatutCod?: string=null;

  // DateTime? DateDepot
  public DateDepot?: Date=null;

  // string DeposePar
  public DeposePar?: string=null;
}